import { ReviewCampaignResponse } from '../../api-models';
import { CampaignReviewed } from '../../types/campaigns.type';
import { HTTPMethod } from '../../types/enums';
import { AdapterInterface } from '../../types/global';
import BaseAdapter from './baseAdapter';

export default class PostReviewCampaign extends BaseAdapter<ReviewCampaignResponse> implements AdapterInterface {
  rawResponse: ReviewCampaignResponse;

  async adaptResponse(request: number): Promise<CampaignReviewed> {
    await this.fetchApiResponse('/api/review-campaign', HTTPMethod.Post, { campaign_communication_id: request });
    return { isApproved: this.rawResponse.is_approved };
  }
}
